import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService, UtilService } from '@app/core';

@Component({
	selector: 'tr-espere-dialog',
	templateUrl: 'espere.dialog.html'
})
export class espereDialog {

	constructor(
	    public dialogRef: MatDialogRef<espereDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private httpService: HttpService,
		private utilService: UtilService
    ) { }
    mensaje = '';

    cerrar() {
        this.utilService.notification('Closing...');
        this.dialogRef.close();
	}

}
